import {
  Bell,
  Building2,
  CalendarClock,
  CalendarDays,
  Circle,
  Home,
  MapPinned,
  Megaphone,
  Newspaper,
  Plane,
  Sun,
  Ticket,
  Trophy,
  User,
  type LucideIcon,
} from 'lucide-react'

export function iconForHref(href: string): LucideIcon {
  if (href === '/') return Home
  if (href.startsWith('/reservation/high-season')) return CalendarClock
  if (href.startsWith('/reservation')) return Building2
  if (href.startsWith('/ticketing')) return Ticket
  if (href.startsWith('/lottery')) return Trophy
  if (href.startsWith('/match-event')) return CalendarDays
  if (href.startsWith('/group-trips')) return Plane
  if (href.startsWith('/listings')) return Megaphone
  if (href.startsWith('/partner-offers')) return MapPinned
  if (href.startsWith('/colony')) return Sun
  if (href.startsWith('/blog')) return Newspaper
  if (href.startsWith('/notifications')) return Bell
  if (href.startsWith('/me')) return User
  return Circle
}
